// Tema do calendário Flatpickr alinhado ao visual do app (cores/fontes de src/utils/defines).
// Sobrepõe o tema padrão (flatpickr/dist/themes/dark.css) — importar depois dele.
// A classe `dhm-fp-other-bound` é aplicada via onDayCreate para destacar, dentro do calendário
// que está aberto, o dia já selecionado no outro campo do range (início ou fim).

/** Marca, no calendário aberto, o dia já escolhido no OUTRO campo do período (início↔fim). */
export function markOtherBound(outroLimite: Date | null) {
    return (_dObj: Date[], _dStr: string, _fp: any, dayElem: HTMLElement) => {
        if (!outroLimite) return
        const el = dayElem as any
        if (el.dateObj && el.dateObj.toDateString() === outroLimite.toDateString()) {
            dayElem.classList.add('dhm-fp-other-bound')
        }
    }
}

export const FP_CALENDAR_THEME = `
.flatpickr-calendar {
    background: #1e2b3a;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 14px;
    box-shadow: 0 12px 32px rgba(0,0,0,0.45);
    font-family: 'Nunito', sans-serif;
}
.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after { display: none; }
.flatpickr-months { padding: 10px 6px 0; }
.flatpickr-month { color: #fff; fill: #fff; }
.flatpickr-current-month { font-family: 'Montserrat', sans-serif; font-size: 14px; padding-top: 2px; }
.flatpickr-current-month input.cur-year { color: #fff; font-family: 'Montserrat', sans-serif; }
.flatpickr-current-month .flatpickr-monthDropdown-months { font-family: 'Montserrat', sans-serif; }
.flatpickr-prev-month, .flatpickr-next-month { color: rgba(255,255,255,0.5); fill: rgba(255,255,255,0.5); }
.flatpickr-prev-month:hover, .flatpickr-next-month:hover { color: #5292D1; fill: #5292D1; }
.flatpickr-weekdays { background: transparent; margin-top: 4px; }
span.flatpickr-weekday {
    background: transparent; color: rgba(255,255,255,0.4);
    font-family: 'Roboto', sans-serif; font-size: 10px;
    text-transform: uppercase; letter-spacing: 0.5px;
}
.flatpickr-days { border: none; }
.flatpickr-day {
    color: rgba(255,255,255,0.75); border-radius: 8px;
    font-family: 'Nunito', sans-serif; font-size: 13px;
}
.flatpickr-day.today { border-color: #5292D1; }
.flatpickr-day.today:hover { border-color: #5292D1; }
.flatpickr-day:hover { background: rgba(82,146,209,0.18); border-color: transparent; }
.flatpickr-day.selected,
.flatpickr-day.selected:hover,
.flatpickr-day.selected:focus {
    background: #5292D1; border-color: #5292D1; color: #fff; font-weight: 700;
}
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay { color: rgba(255,255,255,0.16); }
/* Dia já escolhido no outro campo (início/fim) do range — destacado em verde tracejado. */
.flatpickr-day.dhm-fp-other-bound {
    box-shadow: inset 0 0 0 1.5px #92B258;
    color: #92B258;
}
.flatpickr-day.dhm-fp-other-bound.selected { color: #fff; }
.flatpickr-time { background: transparent; border-top: 1px solid rgba(255,255,255,0.1); height: 38px; }
.flatpickr-time input { color: #fff; background: transparent; font-family: 'Nunito', sans-serif; }
.flatpickr-time .flatpickr-am-pm { color: #fff; }
.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus { background: rgba(255,255,255,0.06); }
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm { color: rgba(255,255,255,0.5); }
.numInputWrapper span.arrowUp:after { border-bottom-color: rgba(255,255,255,0.4); }
.numInputWrapper span.arrowDown:after { border-top-color: rgba(255,255,255,0.4); }
.numInputWrapper:hover { background: transparent; }
`
